// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__xf6mn","validationTips":"StatementDescriptor_validationTips__26xlP"};